var exports = {
  "R3": "TimestampRenderer.module__tooltipContainer___SkYwdl",
  "Mp": "TimestampRenderer.module__tooltipFullDateTime___SkYwdl",
  "fv": "TimestampRenderer.module__tooltipRelativeTime___SkYwdl",
};

module.exports = exports;
